module.exports = __webpack_public_path__ + "img/gael.ca5713ba.png";